import { Grid, Typography } from '@mui/material';
import PropTypes from 'prop-types';
import React from 'react';
import { useSelector } from 'react-redux';
import { useFormContext } from 'react-hook-form';
import FieldContainer from '../../../FormFields/FieldContainer';
import FormButtonOptions from '../../../FormFields/FormButtonOptions';
import FormDataDivider from '../../../FormFields/FormDataDivider';
import FormTitle from '../../../FormFields/FormTitle';
import FormVendorField from '../../../FormFields/FormVendorField';
import { FILE_TYPES } from '../../../formFileTypesEnum';
import { HR } from '../../../formQuestionsEnum';
import { OUTSOURCED_COMPANY_CATEGORIES } from '../../../optionEnums';

TherapySection.propTypes = {
  permissions: PropTypes.object,
};

export default function TherapySection({ permissions }) {
  const {
    data: { outsourcedCompanyCategoriesList },
  } = useSelector((state) => state.transitions);

  const { watch } = useFormContext();
  const therapyOutsourcedCategoryId = watch(HR.THERAPY_OUTSOURCED_CATEGORY_ID.fieldName);
  const shouldShowTherapyVendor = [
    OUTSOURCED_COMPANY_CATEGORIES.CONTRACTED,
    OUTSOURCED_COMPANY_CATEGORIES.IN_HOUSE_CONTRACT_MANAGEMENT,
  ].includes(String(therapyOutsourcedCategoryId));

  return (
    [HR.THERAPY_OUTSOURCED_CATEGORY_ID.id, HR.THERAPY_VENDOR.id, HR.THERAPY_OUTSOURCED_COMP_HAS_HR_FILES.id].some(
      (id) => id in permissions
    ) && (
      <>
        <Grid item xs={12}>
          <Typography variant="subtitle1" color="text.secondary">
            Therapy
          </Typography>
        </Grid>
        {HR.THERAPY_OUTSOURCED_CATEGORY_ID.id in permissions && (
          <Grid item xs={12}>
            <FieldContainer>
              <FormButtonOptions
                fieldName={HR.THERAPY_OUTSOURCED_CATEGORY_ID.fieldName}
                fieldAttributes={{
                  isEditable: permissions[HR.THERAPY_OUTSOURCED_CATEGORY_ID.id],
                  options: outsourcedCompanyCategoriesList.filter(
                    (x) =>
                      x.value === OUTSOURCED_COMPANY_CATEGORIES.CONTRACTED ||
                      x.value === OUTSOURCED_COMPANY_CATEGORIES.IN_HOUSE ||
                      x.value === OUTSOURCED_COMPANY_CATEGORIES.IN_HOUSE_CONTRACT_MANAGEMENT
                  ),
                }}
              />
            </FieldContainer>
          </Grid>
        )}
        {shouldShowTherapyVendor && (
          <>
            {HR.THERAPY_VENDOR.id in permissions && (
              <Grid item xs={12}>
                <FieldContainer>
                  <FormTitle
                    fieldAttributes={{
                      questionTitle: 'Therapy outsourced company',
                      fieldType: 'title',
                    }}
                  />
                  <FormVendorField
                    fieldName={HR.THERAPY_VENDOR.fieldName}
                    fieldAttributes={{
                      isEditable: permissions[HR.THERAPY_VENDOR.id],
                    }}
                    invoiceFileTypeId={FILE_TYPES.THERAPY_OUTSOURCED_COMPANY_INVOICE}
                    contractFileTypeId={FILE_TYPES.THERAPY_OUTSOURCED_COMPANY_CONTRACT}
                  />
                </FieldContainer>
              </Grid>
            )}

            {HR.THERAPY_OUTSOURCED_COMP_HAS_HR_FILES.id in permissions && (
              <Grid item xs={12}>
                <FormTitle
                  fieldAttributes={{ questionTitle: 'Does the contracted company have their own HR files?' }}
                />
                <FormButtonOptions
                  fieldName={HR.THERAPY_OUTSOURCED_COMP_HAS_HR_FILES.fieldName}
                  fieldAttributes={{
                    isEditable: permissions[HR.THERAPY_OUTSOURCED_COMP_HAS_HR_FILES.id],
                    options: [
                      { label: 'Yes', value: true },
                      { label: 'No', value: false },
                    ],
                  }}
                />
              </Grid>
            )}
          </>
        )}
        <FormDataDivider />
      </>
    )
  );
}
